/**
 * Import all module depenencies here.
 * Add commonly used modules to externals.
 */
import core from '../../app.core.module.js';
import forgottenConfig from './forgotten.config.js';
import forgottenRoute from './forgotten.route.js';
import forgottenController from './forgotten.controller.js';
import forgottenService from './forgotten.service.js';
import forgottenDataService from './forgotten.data.service.js';

/**
 * This is the forgotten module. It it the entry point for this website.
 * Only declare the module's dependencies in this file.
 * @namespace Forgotten Module
 */
angular.module('forgotten', [
  // Shared modules.
  core
])
// Register config.
.config(forgottenConfig)
// Register route.
.config(forgottenRoute)
// Register controller.
.controller('forgottenController', forgottenController)
// Register service.
.factory('forgottenService', forgottenService)
// Register data service.
.factory('forgottenDataService', forgottenDataService);

export default 'forgotten';


// WEBPACK FOOTER //
// ./src/login/forgotten/forgotten.module.js